import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  Button, Input, InputRef, Space, Table } from 'antd';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import { fetchInactiveUserbyAdmin } from '../../store/reducers/userDashboardSlice';
import { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import Link from 'antd/es/typography/Link';
import AuditLogModal from '../AuditlogModal/auditLogModal';
import InfoIcon from "../../assets/info_icon.svg";
import moment from 'moment';
import { ColumnType, FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

interface InactiveUserData {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    id: string;
    email: string;
    name: string;
    businessUnit: string;
    employeeId: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    employeeStatus: string;
    accessStatus: string;
    employeeRoles: string[];
    role: string;
}

type DataIndex = keyof InactiveUserData;

const InactiveUserTableContainer = (props: any) => {

  const dispatch = useDispatch();
  const userDashboardData = useSelector((state: any) => state.userDashboard);
  const [inactiveUserData, setInactiveUserData] = React.useState<any>([]);
  
  const [auditLogModalVisible, setAuditLogModalVisible] = useState(false);
  const [selectedemployeeData, setselectedemployeeData] = useState({});
  const [tabName, setTabName] = useState('');
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);
  const [filters, setFilters] = useState<any>([]);

  useEffect(() => {
    if(props.activeTab==='3'){
      fetchInactiveUserbyAdminData(filters);
  }
  }, [dispatch,pageNo,pageSize,props.activeTab]);

  useEffect(() => {
      
    setInactiveUserData(Array.isArray(userDashboardData.inactiveUserList) ? userDashboardData.inactiveUserList : []);
  }, [userDashboardData.inactiveUserList]);

  const fetchInactiveUserbyAdminData = (newFilters:any)=>{
    dispatch(fetchInactiveUserbyAdmin({'page':pageNo,'size':pageSize,'filters':newFilters})).then((res: any) => {
      if (res.type !== 'request/fetchInactiveUserbyAdmin/fulfilled') {
        rejectedApiMessage(res.payload);
      }else{
        setTotalCount(res.payload.totalElements);
    }
    });
  }

  const updateFilters = (field: string, value: string, filters: any[]) => {
    const newFilters = [...filters];
    const index = newFilters.findIndex((filter) => filter.field === field);
    if (index > -1) {
      if (value === '' || value === null || value === undefined) {
        newFilters.splice(index, 1);
      } else
      {
        newFilters[index].value = value;
      }
    } else {
      newFilters.push({ 'field':field, 'value':value,'operator':'LIKE'});
    }
    setFilters(newFilters);
    dispatch(fetchInactiveUserbyAdmin({'page':0,'size':pageSize,'filters':newFilters})).then((res: any) => {
      if (res.type !== 'request/fetchInactiveUserbyAdmin/fulfilled') {
        rejectedApiMessage(res.payload);
      }else{
        setTotalCount(res.payload.totalElements);
        setPageNo(0)
    }
    });
    
  }

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    updateFilters(dataIndex, selectedKeys[0],filters);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex] && record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const _inactiveUser_column: ColumnsType<InactiveUserData> = [
    {
      title: 'Employee Name',
      dataIndex: 'name',
      key: 'inactive_name',
      width: 150,
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Employee Email',
      dataIndex: 'email',
      key: 'inactive_email',
      width: 150,
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Employee Id',
      dataIndex: 'employeeId',
      key: 'inactive_employeeId',
      width: 150,
      ...getColumnSearchProps('employeeId'),
    },
    {
      title: 'Business Unit',
      dataIndex: 'businessUnit',
      key: 'businessUnit',
      width: 150,
      ...getColumnSearchProps('businessUnit'),
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      width: 150,
      ...getColumnSearchProps('department'),
    },
    {
      title: 'Reporting Manager Name',
      dataIndex: 'reportingManagerName',
      key: 'reportingManagerName',
      width: 150,
      ...getColumnSearchProps('reportingManagerName'),
    },
    {
      title: 'Reporting Manager Email',
      dataIndex: 'reportingManagerEmail',
      key: 'reportingManagerEmail',
      width: 150,
      ...getColumnSearchProps('reportingManagerEmail'),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      width: 150,
      ...getColumnSearchProps('role'),
    },
    {
      title: 'Access Revoked On',
      dataIndex: 'accessUpdatedDate',
      key: 'inactive_lastModifiedDate',
      width: 150,
      render: (text: string, record: any) => (
        <span>
          {record.accessUpdatedDate && moment(record.accessUpdatedDate.toString()).format('YYYY-MM-DD')}
        </span>
      ),
    },
    {
      title: 'History',
      dataIndex: 'History',
      key: 'history',
      width:100,
      fixed: 'right',
      render: (text: string, record: any) => (
        <>
          <Link onClick={() => handleHistory(record)}> <img src={InfoIcon} alt='info-icon' /></Link>
        </>
      ),
    }
  ];
  const handleHistory = (record: InactiveUserData) => {
      
    setselectedemployeeData(record);
    setTabName('inactiveUser');
    setAuditLogModalVisible(true);
  };
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPageNo(current ? current - 1 : 0);
    setPageSize(pageSize || 10);
  };

  return (
    <div className="containerr">
      <Table 
      className="table-style" 
      dataSource={[...inactiveUserData]}
      rowKey={'email'} columns={_inactiveUser_column} scroll={{ x: 'max-content',y: 350}}
      loading={userDashboardData?.loading}
      pagination={{
        current: pageNo + 1,
        pageSize,
        total: totalCount,
      }}
      onChange={handleTableChange} />
      <AuditLogModal visible={auditLogModalVisible} onCancel={() => setAuditLogModalVisible(false)} selectedemployeeData={selectedemployeeData} tabName={tabName} />
    </div>
  );
};

export default InactiveUserTableContainer;